module.exports = __webpack_public_path__ + "images/logo-white.3cf7208.svg";